import type { ShareContent, ShareContentGenerator, ShareHook, ShareOptions } from './ShareManager';
import type { TelemetryEventQueue } from '../telemetry/MatomoUtils';

import bind from 'bind-decorator';
import { ShareFilenameManager } from './ShareFilenameManager';

export class ShareTask {
    public readonly itemIds: ReadonlyArray<string>;
    public readonly isCanceled: boolean = false;
    public readonly shareFilenameManager: ShareFilenameManager;
    public readonly telemetryEventQueue?: TelemetryEventQueue;

    public constructor(
        private options: Readonly<ShareOptions>,
        private generators: ReadonlyArray<ShareContentGenerator>,
        private hooks: ReadonlyArray<ShareHook>
    ) {
        this.itemIds = options.itemIds;
        this.shareFilenameManager = new ShareFilenameManager({
            projectName: options.projectName,
            articleFilename: options.articleName,
            allowSubFolders: options.shareAsLink === true
        });
        this.telemetryEventQueue = options.telemetryEventQueue;
    }

    @bind
    public cancel(): void {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        (this.isCanceled as boolean) = true;
    }

    public async *getSharePayloads(): AsyncIterableIterator<ShareContent> {
        for (const hook of this.hooks) {
            await hook.beforeFirstContent?.(this);
        }

        for (const generator of this.generators) {
            if (this.isCanceled) {
                break;
            }

            const matchingFormats = generator.formats?.filter(key => this.options.formats.has(key)) ?? Array.from(this.options.formats);
            if (matchingFormats.length) {
                yield *generator.callback(this, matchingFormats);
            }
        }

        for (const hook of this.hooks) {
            await hook.afterLastContent?.(this);
        }
    }

    public getOptions(): Readonly<ShareOptions> {
        return this.options;
    }
}